/** readable label from Vinted status_code x */
export function formatVintedGoStatusCodeLabel(statusCode: string): string {
  return statusCode
    .trim()
    .replace(/[-_]+/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

function vintedGoEnumKeyToLabel(enumKey: string): string {
  const statusCode = enumKey.replace(/^VINTEDGO_/, '').toLowerCase();
  return formatVintedGoStatusCodeLabel(statusCode);
}

/** Display labels for VintedGo empact statuses (192 dropped_off + 193–219). */
export function getVintedGoStatusLabels<T extends Record<string, number | string>>(
  statusEnum: T,
): Record<number, string> {
  const labels: Record<number, string> = {};

  for (const [key, value] of Object.entries(statusEnum)) {
    if (typeof value !== 'number') {
      continue;
    }
    if (key === 'DROPPED_OFF') {
      labels[value] = formatVintedGoStatusCodeLabel('shipped');
    } else if (key === 'VINTEDGO_CREATED') {
      labels[value] = formatVintedGoStatusCodeLabel('created');
    } else if (key.startsWith('VINTEDGO_')) {
      labels[value] = vintedGoEnumKeyToLabel(key);
    }
  }

  return labels;
}
